import { stateMapping } from '@roc/feature-utils';

export const LICENSE_TYPE_OPTIONS = [
  { label: 'Originator', value: 'ORIGINATOR' },
  { label: 'Company', value: 'COMPANY' },
];

export const US_STATE_OPTIONS = stateMapping;
